import React, { useMemo, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
  TableBody,
  TableCell,
  CardMedia,
  Typography,
  Tabs,
  Tab,
} from '@material-ui/core';
import colors from 'app/constants/colors';
import { desktopMinWidth } from 'utils/windowHelpers';
import { useWindowWidthContext } from 'app/contexts/WindowWidthContext';
import Loading from 'app/components/Loading';
import FeedbackForm from './FeedbackForm';

const CollectionTable = ({ collections, loading }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        fontFamily: 'Poppins',
        minHeight: '500px',
        padding: 40,
      },
      tableContainer: {},
      table: {
        '& .MuiTableCell-body ': {
          background: 'transparent',
        },
        borderBottom: '1px solid #444444',
      },
      tableCell: {
        fontFamily: 'Poppins',
        fontSize: 14,
        paddingTop: 0,
        paddingBottom: 12,
        color: `${colors.white_f2} !important`,
        cursor: 'pointer',
        fontWeight: 500,
        borderBottom: 'none',
        [desktopMinWidth]: {
          minWidth: 80,
          fontSize: 16,
        },
      },
      tableCellCard: {
        fontFamily: 'Poppins',
        padding: '24px 16px 24px 0',
        fontSize: 14,
        borderBottom: 'none',
        color: colors.black_33,
        cursor: 'pointer',
        [desktopMinWidth]: {
          maxWidth: 600,
          paddingRight: 48,
          fontSize: 16,
        },
      },
      tableCellContainer: {
        display: 'flex',
        alignItems: 'center',
      },
      tableHeader: {
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: 12,
        borderColor: '#444444',
        color: colors.gray_aa,
        padding: '0 0 8px 0',
        cursor: 'pointer',
        textTransform: 'uppercase',
        textAlign: 'left',
        [desktopMinWidth]: {
          verticalAlign: 'middle',
          '&:first-child': {
            textAlign: 'left',
          },
        },
      },
      supply: {
        color: colors.gray_aa,
        fontWeight: 400,
        fontSize: 12,
      },
      cardName: {
        color: colors.white_f2,
        fontWeight: 500,
        fontSize: 14,
        [desktopMinWidth]: {
          maxWidth: 436,
          fontSize: 16,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        },
      },
      thumbnailImage: {
        width: 40,
        height: 40,
        objectFit: 'fill',
        borderRadius: '100%',
        marginRight: 12,
      },
      pagination: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 12,
      },
      legend: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        fontSize: 12,
        color: colors.gray_66,
        marginTop: 12,
      },
      waitingIcon: {
        marginRight: 8,
      },
      waitingSpan: {
        color: colors.gray_aa,
      },
      getMore: {
        width: 8,
        height: 8,
      },
      tabContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .Mui-selected': {
          textDecoration: 'none',
          border: `1px solid ${colors.orange}`,
          borderRadius: 4,
        },
      },
      tab: {
        textTransform: 'none',
        width: 'auto',
        height: 'auto',
        minWidth: 'initial',
      },
      tabs: {
        marginBottom: 24,
      },
      feedbackForm: {
        marginTop: 32,
        [desktopMinWidth]: {
          marginTop: 40,
        },
      },
      newTag: {
        marginLeft: 8,
        background: colors.brand_yellow,
        fontWeight: 700,
        fontSize: 10,
        color: colors.black_33,
        height: 16,
        padding: '2px 6px',
        borderRadius: '50px',
      },
    }),
  );

  const classes = useStyles();
  const { isDesktopView } = useWindowWidthContext();
  const columns = useMemo(
    () =>
      isDesktopView
        ? ['Collection', 'Floor (ETH)', 'Avg (ETH)', 'Vol']
        : ['Collection', 'Floor (ETH)'],
    [isDesktopView],
  );

  const goToCollection = slug => {
    window.open(`https://opensea.io/collection/${slug}`, '_blank');
  };

  return (
    <div className={classes.root}>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className={classes.tabContainer}>
            {/*<Tabs*/}
            {/*  value={currentTab}*/}
            {/*  onChange={(e, val) => setCurrentTab(val)}*/}
            {/*  className={classes.tabs}*/}
            {/*  TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}*/}
            {/*>*/}
            {/*  <Tab*/}
            {/*    label="Current"*/}
            {/*    className={classes.tab}*/}
            {/*    key={0}*/}
            {/*    selected={currentTab === 0}*/}
            {/*    value={0}*/}
            {/*    disableRipple={true}*/}
            {/*  />*/}
            {/*  <Tab*/}
            {/*    label="1d"*/}
            {/*    className={classes.tab}*/}
            {/*    key={1}*/}
            {/*    selected={currentTab === 1}*/}
            {/*    value={1}*/}
            {/*    disableRipple={true}*/}
            {/*  />*/}
            {/*  <Tab*/}
            {/*    label="7d"*/}
            {/*    className={classes.tab}*/}
            {/*    key={2}*/}
            {/*    selected={currentTab === 2}*/}
            {/*    value={2}*/}
            {/*    disableRipple={true}*/}
            {/*  />*/}
            {/*  <Tab*/}
            {/*    label="30d"*/}
            {/*    className={classes.tab}*/}
            {/*    key={3}*/}
            {/*    selected={currentTab === 3}*/}
            {/*    value={3}*/}
            {/*    disableRipple={true}*/}
            {/*  />*/}
            {/*</Tabs>*/}
          </div>
          <TableContainer className={classes.tableContainer}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {columns?.map((column, index) => (
                    <TableCell className={classes.tableHeader} key={index}>
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {collections?.map((item: any, index: number) => {
                  const { img, stats, name, collectionSlug, isNew } =
                    item || {};
                  const {
                    total_volume,
                    floor_price,
                    average_price,
                    total_supply,
                  } = stats || {};
                  return [
                    <TableRow
                      key={index}
                      onClick={() => goToCollection(collectionSlug)}
                    >
                      <TableCell align="left" className={classes.tableCellCard}>
                        <div className={classes.tableCellContainer}>
                          <div>
                            <CardMedia
                              className={classes.thumbnailImage}
                              image={img}
                            />
                          </div>
                          <div>
                            <Typography
                              variant="body1"
                              className={classes.cardName}
                            >
                              {name}
                              {isNew && (
                                <span className={classes.newTag}>NEW!</span>
                              )}
                            </Typography>
                            <Typography
                              variant="body1"
                              className={classes.supply}
                            >
                              Supply: {total_supply?.toLocaleString()}
                            </Typography>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell
                        className={`${classes.tableCell}`}
                        align="left"
                      >
                        {floor_price?.toFixed(3)?.toLocaleString()}
                      </TableCell>
                      {isDesktopView && (
                        <>
                          <TableCell
                            className={`${classes.tableCell}`}
                            align="left"
                          >
                            {average_price?.toFixed(3)?.toLocaleString()}
                          </TableCell>
                          <TableCell
                            className={`${classes.tableCell}`}
                            align="left"
                          >
                            {total_volume?.toFixed(3)?.toLocaleString()}
                          </TableCell>
                        </>
                      )}
                    </TableRow>,
                  ];
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
      <div className={classes.feedbackForm}>
        <FeedbackForm />
      </div>
    </div>
  );
};

export default CollectionTable;
